import { createModalsFactory } from 'ui';

type DonationSettingModalIds =
  | 'ManageRecurring'
  | 'EditRecurring'
  | 'UpdatePayment'
  | 'CancelDonation'
  | 'EditAllocation';

type DonationSettingsMeta = {
  subscriptionId?: string;
};

const {
  Provider: DonationSettingModalProvider,
  useProvider: useDonationSettingModalProvider,
  ModalTitleWithBackButton,
} = createModalsFactory<DonationSettingModalIds[], DonationSettingsMeta>([
  'ManageRecurring',
  'EditRecurring',
  'UpdatePayment',
  'CancelDonation',
  'EditAllocation',
]);

export { DonationSettingModalProvider, ModalTitleWithBackButton, useDonationSettingModalProvider };
